import { bindActionCreators } from 'redux'
import {
  getDsrFeedContent,
  resetDsrFeedContent,
  resetDsrPages,
  resetDsrSelectedDisplaySubpage,
  resetDsrTitle,
  setShowDsrModal,
  setUserActionRequired,
  updateDsrReset,
} from '../actions/dsr-actions'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { duplicateDsrPage } from '../actions/duplicate-dsr-page-actions'
import { DsrTemplateEditPage } from './DsrTemplateEditPage'
import { fetchDsrTemplateData, updateDsrTemplate } from '../actions/dsr-template-actions'
import { unlockRoom } from '../../global/actions/global-actions'

const DsrTemplateEditPageContainer = (props) => {
  return <DsrTemplateEditPage {...props} />
}
const mapStateToProps = (state) => ({
  currentDsrId: state.dsrFeedContent.id,
  dsrPagesRedux: state.setDsrPages.pages,
  dsrInvalidRequestRedux: state.dsrInvalidRequest.request,
  showDsrModalRedux: state.dsrModal.showDsrModal,
  userActionRequiredRedux: state.dsrPopup.UserActionRequired,
  dsrTitle: state.dsrTitle.title,
  showDsrModalLoaderRedux: state.showDsrModalLoader.show,
  selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
  isMobileView: state.mobileViewMode.isMobileView,
  dsrTemplateId: state.dsrTemplateId.results,
  userAccountProfile: state.userProfile.accountUserProfile,
  isLockedRoom :state.lockedRoomCheck.isLockedRoom,
  lockedRoomMetadata: state.lockedRoomMetadata.results
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDsrFeedContent,
      setShowDsrModal,
      setUserActionRequired,
      resetDsrFeedContent,
      resetDsrTitle,
      resetDsrSelectedDisplaySubpage,
      resetDsrPages,
      duplicateDsrPage,
      updateDsrReset,
      fetchDsrTemplateData,
      updateDsrTemplate,
      unlockRoom
    },
    dispatch,
  )

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DsrTemplateEditPageContainer),
)
